import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../../Store';

export default function AgentRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  return userInfo && userInfo.isAgent ? children : <Navigate to="/signin" />;
}
